import styled from "styled-components";
import tw from "twin.macro";

export const GenericHeaderStyles = styled.div`
  ${tw`px-4 max-w-6xl mx-auto`}

  .generic-header__content {
    margin-bottom: 20px;
    display: grid;
    grid-gap: 20px;
    @media (max-width: 619px) {
      grid-template-columns: 1fr;
    }
    @media (min-width: 620px) {
      border-bottom: 5px solid #0071ba;
      grid-template-columns: 1fr minmax(auto, 220px);
    }
    &--no-topics {
      display: block;
      margin: 0;
      border: none;
    }
  }
`;

export const Header = styled.div`
  h1 {
    ${tw`font-bold mb-4 text-blue-500 tracking-tighter leading-tight text-4xl md:text-5xl mb-3`}
    @media (max-width: 619px) {
      margin-bottom: 0;
    }
  }
`;
